export const type = 'distribute-player';

export const Size = {
  SMALL: 'sm',
  MEDIUM: 'md',
} as const;
